import Logo from '@/assets/images/OMIKUJI Main Logo.png';
import Logo2 from '@/assets/images/LogoOmiKuji.png';
import BackgroundHeader from '@/assets/icons/BackgroundHeader';
import LogoOmi from '@/assets/icons/LogoOmikuji';
import { Button } from '@/components/common/Button';
import { ROUTES } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { cn } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Menu from './_components/Menu';

export default observer(function SideBar() {
    // hooks
    const { t } = useTranslation();

    // store
    const {
        uiStore: { isOpenSidebar }
    } = useStore();

    return (
        <aside
            className={cn(
                'fixed top-0 left-0 z-20 h-screen -translate-x-full lg:translate-x-0 transition-[width] ease-in-out duration-300 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
                isOpenSidebar === false ? 'w-[92px]' : 'w-72'
            )}
        >
            {/* <SidebarToggle /> */}

            <div className='relative h-full flex flex-col shadow-md dark:shadow-zinc-800'>
                {/* Brand top */}
                <Button
                    className={cn(
                        'transition-transform ease-in-out duration-300 h-16 px-0',
                        isOpenSidebar === false ?
                            'translate-x-0 px-1' :
                            'translate-x-0'
                    )}
                    variant='link'
                    asChild
                >
                    <Link
                        to={ROUTES.userManagement.href}
                        className='flex items-center p-0 m-0 w-full'
                    >
                        {
                            !isOpenSidebar ?
                                (
                                    <img src={Logo} alt='Logo' className='transition-all ease-in-out duration-300 h-16 object-contain' />
                                ) :
                                (
                                    <div className='h-16 bg-active w-full transition-all ease-in-out duration-300'>
                                        <img src={Logo2} alt='Logo' className='h-full w-full transition-all ease-in-out duration-300' />
                                    </div>
                                )
                        }

                    </Link>
                </Button>

                {/* Menu */}
                <Menu isOpen={isOpenSidebar} />
            </div>
        </aside>
    );
});
